import React from 'react';
import { Input } from '@/components/ui';
import type { UserEditFormData } from '../types/userEdit.types';

interface Props {
  formData: UserEditFormData;
  updateField: (field: keyof UserEditFormData, value: any) => void;
}

export function EditEmergencyInfo({ formData, updateField }: Props) {
  return (
    <div className="bg-white rounded-md p-6 border border-slate-100 w-full h-full">
      <h2 className="sm:text-sm text-xs font-medium text-slate-800 mb-6">Thông tin liên hệ khẩn cấp</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Họ và tên người liên hệ"
          placeholder="Nhập tên người thân"
          value={formData.emergency_contact_name || ''}
          onChange={(e: any) => updateField('emergency_contact_name', e.target.value)}
        />
        <Input
          label="Số điện thoại khẩn cấp"
          placeholder="Nhập số điện thoại"
          value={formData.emergency_contact_phone || ''}
          onChange={(e: any) => updateField('emergency_contact_phone', e.target.value)}
        />
        <Input
          label="Mối quan hệ"
          placeholder="VD: Vợ, Chồng, Bố, Mẹ..."
          value={formData.emergency_contact_relation || ''}
          onChange={(e: any) => updateField('emergency_contact_relation', e.target.value)}
        />
      </div>
    </div>
  );
}
